import { ImportMetaEnv } from './ImportMetaEnv';

export const dev: ImportMetaEnv = {
  NODE_ENV: 'development',
  BASE_API: '/staff',
};
